import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import pageMixin from "../mixins/page";
import Axios from "axios";
import GroupModal from "./GroupModal";
import TableDetailModal from "./TableDetailModal";
export default {
  name: "group-modal",
  mixins: [pageMixin],
  components: {
    GroupModal: GroupModal,
    TableDetailModal: TableDetailModal
  },
  data: function data() {
    return {
      searchText: "",
      columns: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "名称",
        sortable: true,
        key: "name"
      }, {
        title: "权限",
        key: "permission_text",
        sortable: false
      }, {
        title: "最大试用点数",
        key: "max_point_num"
      }, {
        title: "最大试用天数",
        key: "max_trial_days"
      }, {
        title: "操作",
        align: 'center',
        width: '100',
        slot: 'btns'
      }],
      data: [],
      selection: [],
      showCreateModal: false,
      showUpdateModal: false,
      // 角色详情
      showTableDetail: false,
      tableDetail: {},
      tableDetailColumns: [{
        title: "名称",
        sortable: true,
        key: "name"
      }, {
        title: "权限",
        key: "permission_text",
        sortable: false
      }, {
        title: "最大试用点数",
        key: "max_point_num"
      }, {
        title: "最大试用天数",
        key: "max_trial_days"
      }, {
        title: "产品明细",
        key: "productdetails_text",
        sortable: false
      }]
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("users/groups/", {
        params: {
          name: this.searchText,
          order_by: this.sortKey,
          page: this.currentPage,
          per_page: this.pageSize
        }
      }).then(function (resp) {
        var groups = resp.data.groups;
        groups.forEach(function (g) {
          g.permission_text = g.permissions.map(function (p) {
            return p.name;
          }).join(",");
          g.productdetails_text = g.productdetails.map(function (p) {
            return p.product_name;
          }).join(",");
        });
        _this.data = groups;
        _this.total = _this.data.length; //Todo : 等待后端接口吧count信息返回再修改为this.setPageVars(resp.data.page_info)
      }).then(onFinish, onFinish);
    },
    onModalClose: function onModalClose(val) {
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    },
    viewDetails: function viewDetails(rows) {
      this.tableDetail = rows;
      this.showTableDetail = true;
    },
    remove: function remove() {
      var _this2 = this;
      Axios.delete("users/groups/".concat(this.selection[0].id, "/")).then(function () {
        return _this2.refresh();
      }, function (e) {
        throw e;
      });
    }
  }
};